import React from 'react';
import { Tooltip as MaterialTooltip } from '@mui/material';
import { TooltipProps as MaterialTooltipProps } from '@mui/material/Tooltip';

import './Tooltip.scss';

interface ContainerProps {
  value?: React.ReactNode;
  title?: React.ReactNode;
  placement?: MaterialTooltipProps['placement'];
  children?: React.ReactNode;
}

const sharedPopperProps = {
  style: {
    pointerEvents: 'none',
  },
  modifiers: [
    {
      name: 'pointerEventsFix',
      enabled: true,
      phase: 'afterWrite',
      fn({ state }: any) {
        Object.assign(state.elements.popper.style, {
          pointerEvents: 'none',
        });
      },
    },
  ],
} as MaterialTooltipProps['PopperProps'];

const Tooltip: React.FC<ContainerProps> = ({
  value = 'Dolor sit amet, consectetur adipiscing elit and another long sentence added.',
  title,
  placement,
  children,
}) => {
  const tooltipTitle = title ?? value;

  if (children !== undefined && children !== null) {
    const childElement = React.isValidElement(children) ? children : <span>{children}</span>;
    const isDisabledChild =
      React.isValidElement<{ disabled?: boolean }>(childElement) && Boolean(childElement.props.disabled);
    const tooltipChild = isDisabledChild ? (
      <span style={{ display: 'inline-flex' }}>{childElement}</span>
    ) : (
      childElement
    );

    return (
      <MaterialTooltip placement={placement} title={tooltipTitle} PopperProps={sharedPopperProps}>
        {tooltipChild}
      </MaterialTooltip>
    );
  }

  return (
    <span className="tooltip">
      <MaterialTooltip placement={placement} title={tooltipTitle} PopperProps={sharedPopperProps}>
        <img src={'assets/icons/info-icon.svg'} alt="" />
      </MaterialTooltip>
    </span>
  );
};

export default Tooltip;
